import { Navigate, useParams } from "react-router-dom";

// Redirect legacy agency-profile URLs to the consolidated public /advisor/:slug route.
// Covers the index plus nested blog/form paths via the splat param so a single
// route handles /…/:agencyId, /…/:agencyId/blog, /…/:agencyId/blog/:postSlug, /…/:agencyId/form/:formId.
const LegacyProfileRedirect = () => {
  const params = useParams();
  const rest = params["*"];
  const target = `/advisor/${params.agencyId}${rest ? `/${rest}` : ""}`;
  return <Navigate to={target} replace />;
};

export default LegacyProfileRedirect;
